import React, { useEffect } from 'react';
import { Modal, Form, Input, InputNumber, Switch, message, Select } from 'antd';
import { StarOutlined, StarFilled } from '@ant-design/icons';
import { useSales } from '../SalesContext';
import { Product } from '../types';

const { Option } = Select;

interface ProductFormModalProps {
  visible: boolean;
  onClose: () => void;
  product: Product | null;
  defaultSectionId?: number | null;
  onSuccess: () => void;
}

const ProductFormModal: React.FC<ProductFormModalProps> = ({
  visible,
  onClose,
  product,
  defaultSectionId,
  onSuccess
}) => {
  const [form] = Form.useForm();
  const { createProduct, updateProduct, sections } = useSales();

  useEffect(() => {
    if (visible) {
      if (product) {
        form.setFieldsValue({
          ...product,
          section_id: product.section_id
        });
      } else {
        form.resetFields();
        form.setFieldsValue({
          section_id: defaultSectionId,
          is_active: true,
          highlighted: false,
          commission: 0
        });
      }
    }
  }, [visible, product, defaultSectionId, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();

      if (product) {
        await updateProduct(product.id, values);
        message.success('Produto atualizado');
      } else {
        await createProduct(values);
        message.success('Produto criado');
      }
      onSuccess();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal
      title={product ? 'Editar Produto' : 'Novo Produto'}
      open={visible}
      onCancel={onClose}
      onOk={handleSubmit}
      destroyOnClose
      className="admin-form-modal"
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="name"
          label="Nome do Produto"
          rules={[{ required: true, message: 'Por favor insira o nome' }]}
        >
          <Input placeholder="Ex: Fibra 500Mbps" />
        </Form.Item>

        <Form.Item
          name="section_id"
          label="Secção"
          rules={[{ required: true, message: 'Selecione uma secção' }]}
        >
          <Select placeholder="Selecione a secção">
            {sections.map(s => (
              <Option key={s.id} value={s.id}>
                {s.name} ({s.business_area})
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="commission"
          label="Pontos"
        >
          <InputNumber<number>
            min={0}
            precision={0}
            style={{ width: '100%' }}
            placeholder="Ex: 50"
          />
        </Form.Item>

        <div style={{ display: 'flex', gap: 24 }}>
          <Form.Item
            name="highlighted"
            label="Destaque"
            valuePropName="checked"
          >
            <Switch
              checkedChildren={<StarFilled />}
              unCheckedChildren={<StarOutlined />}
            />
          </Form.Item>

          <Form.Item
            name="is_active"
            label="Ativo (Estado)"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};

export default ProductFormModal;


